import produce from 'immer';

import {
  AGENCY_BOUNDARY_CREATE_FAILURE,
  AGENCY_BOUNDARY_CREATE_SUCCESS,
  AGENCY_BOUNDARY_NAME_FETCH_FAILURE,
  AGENCY_BOUNDARY_NAME_FETCH_SUCCESS,
  AGENCY_MAP_LAYER_EDIT_FAILURE,
  AGENCY_MAP_LAYER_EDIT_SUCCESS,
  AGENCY_MAP_LAYER_FETCH_FAILURE,
  AGENCY_MAP_LAYER_FETCH_SUCCESS,
  ALL_PARCEL_FIELD_LIST_FETCH_FAILURE,
  ALL_PARCEL_FIELD_LIST_FETCH_SUCCESS,
  FETCH_CONFIG_GIS_FIELDS_FAILURE,
  FETCH_CONFIG_GIS_FIELDS_SUCCESS,
  FETCH_CONFIG_GIS_MAPPING_FAILURE,
  FETCH_CONFIG_GIS_MAPPING_SUCCESS,
  GET_SECURE_LOCATION_SETTINGS_FAILURE,
  GET_SECURE_LOCATION_SETTINGS_SUCCESS,
  KML_CREATE_FAILURE,
  KML_CREATE_SUCCESS,
  KML_EDIT_FAILURE,
  KML_EDIT_SUCCESS,
  KML_FETCH_FAILURE,
  KML_FETCH_SUCCESS,
  KML_LIST_EDIT_SEQUENCE_FAILURE,
  KML_LIST_EDIT_SEQUENCE_SUCCESS,
  KML_LIST_FETCH_FAILURE,
  KML_LIST_FETCH_SUCCESS,
  LOCATION_SEARCH_CLEAR,
  LOCATION_SEARCH_FAILURE,
  LOCATION_SEARCH_REQUEST,
  LOCATION_SEARCH_SUCCESS,
  MAP_CONFIG_FETCH_FAILURE,
  MAP_CONFIG_FETCH_REQUEST,
  MAP_CONFIG_FETCH_SUCCESS,
  MAP_SETTINGS_EDIT_FAILURE,
  MAP_SETTINGS_EDIT_SUCCESS,
  MAP_SETTINGS_FETCH_FAILURE,
  MAP_SETTINGS_FETCH_SUCCESS,
  PARCEL_CLEAR,
  PARCEL_FIELD_LIST_FETCH_FAILURE,
  PARCEL_FIELD_LIST_FETCH_SUCCESS,
  PARCEL_SEARCH_FAILURE,
  PARCEL_SEARCH_REQUEST,
  PARCEL_SEARCH_SUCCESS,
  SET_PARCEL,
  SHAPEFILE_CREATE_FAILURE,
  SHAPEFILE_CREATE_SUCCESS,
  SHAPEFILE_NAME_FETCH_FAILURE,
  SHAPEFILE_NAME_FETCH_SUCCESS,
  UPDATE_SECURE_LOCATION_SETTINGS_FAILURE,
  UPDATE_SECURE_LOCATION_SETTINGS_SUCCESS,
} from '@actions/gis';

const initialState: IGisStore = {
  shapefile: null,
  cdbgUploadStatus: null,
  agencyBoundaryFile: null,
  currentMapLayer: null,
  mapLayers: null,
  isFetching: false,
  error: null,
  agencyMapSettings: null,
  parcelFields: null,
  allParcelFields: null,
  securedLocationSettings: null,
  gisFields: null,
  isGISWorking: false,
  gisMapping: null,
  // TODO: remove if unneccessary.
  locationSearchResult: null,
  parcelFileDetails: null,
  parcel: null,
  parcelSearchUniqueIdentifier: null,
  config: null,
};

export default (state: IGisStore = initialState, action: any) =>
  produce(state, (draftState: IGisStore) => {
    switch (action.type) {
      case SHAPEFILE_CREATE_SUCCESS:
        draftState.shapefile = null;
        draftState.error = null;

        return;

      case SHAPEFILE_CREATE_FAILURE:
      case SHAPEFILE_NAME_FETCH_FAILURE:
        draftState.shapefile = null;
        draftState.error = action.error;

        return;

      case SHAPEFILE_NAME_FETCH_SUCCESS:
        draftState.shapefile = action.response.fileName;
        draftState.cdbgUploadStatus = action.response.uploadStatus;
        draftState.error = null;

        return;

      case KML_CREATE_FAILURE:
      case KML_EDIT_FAILURE:
      case KML_FETCH_FAILURE:
        draftState.currentMapLayer = null;
        draftState.error = action.error;

        return;

      case KML_CREATE_SUCCESS:
      case KML_EDIT_SUCCESS:
      case KML_FETCH_SUCCESS:
        draftState.currentMapLayer = action.response;
        draftState.error = null;

        return;

      case KML_LIST_FETCH_SUCCESS:
      case KML_LIST_EDIT_SEQUENCE_SUCCESS:
        draftState.mapLayers = action.response;
        draftState.error = null;

        return;

      case KML_LIST_FETCH_FAILURE:
      case KML_LIST_EDIT_SEQUENCE_FAILURE:
        draftState.mapLayers = null;
        draftState.error = action.error;

        return;

      // TODO: remove if unneccessary.
      case MAP_CONFIG_FETCH_REQUEST:
        draftState.config = null;
        draftState.isFetching = true;
        draftState.error = null;

        return;

      case MAP_CONFIG_FETCH_SUCCESS:
        draftState.config = action.response;
        draftState.isFetching = false;
        draftState.error = null;

        return;

      case MAP_CONFIG_FETCH_FAILURE:
        draftState.config = null;
        draftState.isFetching = false;
        draftState.error = action.error;

        return;

      case AGENCY_BOUNDARY_CREATE_SUCCESS:
        draftState.agencyBoundaryFile = null;
        draftState.error = null;

        return;

      case AGENCY_BOUNDARY_CREATE_FAILURE:
      case AGENCY_BOUNDARY_NAME_FETCH_FAILURE:
        draftState.error = action.error;

        return;

      case AGENCY_BOUNDARY_NAME_FETCH_SUCCESS:
        draftState.agencyBoundaryFile = action.response;
        draftState.error = null;

        return;

      case LOCATION_SEARCH_REQUEST:
        draftState.locationSearchResult = null;
        draftState.isFetching = false;
        draftState.error = null;

        return;

      case LOCATION_SEARCH_SUCCESS:
        draftState.locationSearchResult = action.response;
        draftState.isFetching = false;
        draftState.error = null;

        return;

      case LOCATION_SEARCH_FAILURE:
        draftState.locationSearchResult = null;
        draftState.isFetching = false;
        draftState.error = action.error;

        return;

      case LOCATION_SEARCH_CLEAR:
        draftState.locationSearchResult = null;

        return;

      case PARCEL_SEARCH_REQUEST:
        draftState.parcel = null;
        draftState.isFetching = true;
        draftState.parcelSearchUniqueIdentifier = action.uniqueIdentifier || null;

        return;

      case PARCEL_SEARCH_SUCCESS:
        if ((action.uniqueIdentifier || null) !== draftState.parcelSearchUniqueIdentifier) {
          return;
        }
        draftState.parcel = action.response;
        draftState.isFetching = false;
        draftState.error = null;
        draftState.parcelSearchUniqueIdentifier = null;

        return;

      case SET_PARCEL:
        draftState.parcel = action.response;
        draftState.isFetching = false;
        draftState.error = null;
        draftState.parcelSearchUniqueIdentifier = null;

        return;

      case PARCEL_SEARCH_FAILURE:
        if ((action.uniqueIdentifier || null) !== draftState.parcelSearchUniqueIdentifier) {
          return;
        }
        draftState.parcel = null;
        draftState.isFetching = false;
        draftState.error = action.error;
        draftState.parcelSearchUniqueIdentifier = null;

        return;

      case PARCEL_CLEAR:
        draftState.parcel = null;
        draftState.isFetching = false;
        draftState.error = action.error;
        draftState.parcelSearchUniqueIdentifier = null;

        return;

      case MAP_SETTINGS_EDIT_FAILURE:
      case MAP_SETTINGS_FETCH_FAILURE:
        draftState.shapefile = null;
        draftState.error = action.error;

        return;

      case MAP_SETTINGS_EDIT_SUCCESS:
      case MAP_SETTINGS_FETCH_SUCCESS:
        draftState.agencyMapSettings = action.response;
        draftState.error = null;

        return;

      case AGENCY_MAP_LAYER_FETCH_SUCCESS:
        draftState.parcelFileDetails = action.response;
        draftState.error = null;

        return;

      case AGENCY_MAP_LAYER_EDIT_SUCCESS:
        draftState.error = null;

        return;

      case AGENCY_MAP_LAYER_EDIT_FAILURE:
        draftState.error = action.error;

        return;

      case AGENCY_MAP_LAYER_FETCH_FAILURE:
        draftState.parcelFileDetails = null;
        draftState.error = action.error;

        return;

      case PARCEL_FIELD_LIST_FETCH_SUCCESS:
        draftState.parcelFields = action.response;
        draftState.error = null;

        return;

      case PARCEL_FIELD_LIST_FETCH_FAILURE:
        draftState.parcelFields = null;
        draftState.error = action.error;

        return;

      case ALL_PARCEL_FIELD_LIST_FETCH_SUCCESS:
        draftState.allParcelFields = action.response;
        draftState.error = null;

        return;

      case ALL_PARCEL_FIELD_LIST_FETCH_FAILURE:
        draftState.allParcelFields = null;
        draftState.error = action.error;

        return;

      case GET_SECURE_LOCATION_SETTINGS_FAILURE:
      case UPDATE_SECURE_LOCATION_SETTINGS_FAILURE:
        draftState.error = action.error;

        return;

      case GET_SECURE_LOCATION_SETTINGS_SUCCESS:
        draftState.securedLocationSettings = action.response;
        draftState.error = null;

        return;

      case UPDATE_SECURE_LOCATION_SETTINGS_SUCCESS:
        draftState.securedLocationSettings = action.response.data;
        draftState.error = null;

        return;

      case FETCH_CONFIG_GIS_FIELDS_SUCCESS:
        draftState.gisFields = action.response.fields;
        draftState.isGISWorking = action.response.isGISWorking;
        draftState.error = null;

        return;

      case FETCH_CONFIG_GIS_FIELDS_FAILURE:
        draftState.gisFields = null;
        draftState.isGISWorking = false;
        draftState.error = action.error;

        return;

      case FETCH_CONFIG_GIS_MAPPING_SUCCESS:
        draftState.gisMapping = action.response.mapping;
        draftState.error = null;

        return;

      case FETCH_CONFIG_GIS_MAPPING_FAILURE:
        draftState.gisMapping = null;
        draftState.error = action.error;

        return;
    }
  });
